import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';

import Builder from './components/builder';
import Helpers from './components/helpers';
import GtmTracker from './components/gtm_tracker';
import Reveal from './components/reveal';


let builderInstance = new Builder();
let helpersInstance = new Helpers();
let gtmTracker = new GtmTracker();
let revealInstance = new Reveal();
let swup = null;


const SWUP_ENABLED = typeof window.wp_data.spa_hybrid !== 'undefined' && !!window.wp_data.spa_hybrid;


if (SWUP_ENABLED && !document.body.classList.contains('logged-in')) {
    const options = {
        containers: ["#container"],
        animationSelector: '[class*="transition-"]',
        native: true,
        plugins: [
            new SwupBodyClassPlugin(),
            new SwupPreloadPlugin({
                preloadInitialPage: true,
                preloadHoveredLinks: true,
                preloadVisibleLinks: {
                    enabled: true,
                    threshold: 0.2,
                    delay: 800,
                    containers: ['#container']
                },
                ignore: () => navigator.connection?.saveData === true
            }),
            new SwupScrollPlugin({
                doScrollingRightAway: false,
                animateScroll: {
                    betweenPages: true,
                    insidePages: true
                }
            }),
            new SwupScriptsPlugin({
                head: false,
                body: false
            })
        ],
    };
    swup = new Swup(options);

    swup.hooks.before('content:replace', () => {
        revealInstance.destroy();
        builderInstance.destroy();
        helpersInstance.destroy();
        gtmTracker.destroy();
    });

    swup.hooks.on('content:replace', () => {
        builderInstance.init();
        helpersInstance.init();
        gtmTracker.init();
        revealInstance.init();
    });

    swup.hooks.on('page:view', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'pageview',
            page: {
                url: window.location.pathname,
                title: document.title
            }
        });
        // header/footer żyją poza #container — informujemy je o zmianie strony (aktywny link menu)
        document.dispatchEvent(new CustomEvent('dekret:pageview'));
    });
}

async function initHeaderFooter() {

    await Builder.initGlobals();
}

async function start() {
    await initHeaderFooter();
    builderInstance.init();
    helpersInstance.init();
    gtmTracker.init();
    revealInstance.init();
}

document.addEventListener('DOMContentLoaded', start, false);
